/**
 * Sort utility functions for arrays of objects based on specific keys.
 * Puts NaN values at the end of the sorted array (stable order).
 */
export const byNumericKey =
  <T>(key: keyof T, isAsc: boolean = true) =>
  (a: T, b: T): number => {
    const va = a[key] as unknown as number;
    const vb = b[key] as unknown as number;

    // NaN Check (Fastest: NaN is the only value not equal to itself)
    const aIsNan = va !== va;
    const bIsNan = vb !== vb;

    if (aIsNan || bIsNan) {
      if (aIsNan && bIsNan) return 0;
      return aIsNan ? 1 : -1; // NaNs sink to the back
    }

    return isAsc ? va - vb : vb - va;
  };

/**
 * A no-operation comparator frunction that leaves the array order unchanged.
 * @returns always returns 0 so that the sort order is not changed.
 */
export const noOpSorter = () => 0;
